import React from "react";
import Title from "../../../UI/organisms/Title/Title";

import "./Questions.scss";
import { QuestionsType } from "../../../../types/CoursesTypes";
import { useBuyButton } from "../Header/hooks/useBuyButton";

const Questions = ({
  questions,
  flag,
}: {
  questions: QuestionsType;
  flag?: string;
}) => {
  const publicUrl = process.env.PUBLIC_URL;
  const { BuyButtonHandle } = useBuyButton("header", publicUrl);
  const titleData = {
    intro: "Dê uma olhada nas",
    title: "Perguntas frequentes",
  };

  function openQuestion(t: EventTarget | HTMLElement) {
    if (t instanceof HTMLElement) {
      if (t.classList.contains("questions__list--item"))
        t.classList.toggle("open");
      else
        t.parentElement?.classList.contains("questions__list--item")
          ? t.parentElement?.classList.toggle("open")
          : t.parentElement?.parentElement?.classList.toggle("open");
    }
  }

  const { list, offer, start } = questions;

  return (
    <section id="questions" className="questions__content">
      {flag && <img src={flag} alt="flag" className="flag" />}

      <Title info={titleData} tag="h2" />

      <div className="questions__list">
        {list.map((q) => (
          <div
            key={q.question}
            className={`questions__list--item ${start}`}
            onClick={(e) => openQuestion(e.target)}
          >
            <div className="title">{q.question}</div>
            <div className="text">
              <p dangerouslySetInnerHTML={{ __html: `${q.answer}` }}></p>
            </div>
          </div>
        ))}
      </div>

      {questions.offer && (
        <div className={`questions__button`}>
          {offer?.link && BuyButtonHandle(offer)}
        </div>
      )}
    </section>
  );
};

export default Questions;
